import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added a context value',
  name: 'context_value_added',
  params: [
    {
      description: 'The source of the addition',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['onboarding', 'add_domain', 'agent', 'manual'],
    },
    {
      description: 'The value type of the field',
      name: 'value_type',
      required: true,
      type: 'enum',
      values: ['text', 'file', 'color', 'font'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the value has a label',
      name: 'label',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Whether the value has an AI instruction',
      name: 'ai_instruction',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
